function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Warning_icon",
  transform: "translate(-1.723 -4.46)"
}, React.createElement("path", {
  id: "Path_1100",
  "data-name": "Path 1100",
  d: "M3,58,32,6,61,58Z",
  fill: "none",
  stroke: "#f05a5c",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), React.createElement("line", {
  id: "Line_411",
  "data-name": "Line 411",
  y2: 19,
  transform: "translate(32 23)",
  fill: "none",
  stroke: "#f05a5c",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), React.createElement("circle", {
  id: "Ellipse_137",
  "data-name": "Ellipse 137",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(31 48)",
  fill: "none",
  stroke: "#f05a5c",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}));

const SvgWarningIcon = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60.554,
    height: 54.29,
    viewBox: "0 0 60.554 54.29",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgWarningIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning_icon.54ed901a.svg";
export { ForwardRef as ReactComponent };